import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useMotoresSection } from "./use-motores-section";
import { MotoresSectionView } from "./view-motores-section";

export function MotoresSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useMotoresSection(props);

  return <MotoresSectionView {...vm} />;
}

export type * from "./types-motores-section";
